define('modules/lists/models/following.list.limit.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function (_, Backbone, BaseModel) {
    var FollowingListLimitModel = BaseModel.extend({
        base: 'list/following/limit',
        url:function(){
            return window.utils.makeUrl('prospector/v1/' + this.base + "/" + this.get('id') + "?alertType=" + this.alertType);
        },
    });
    return FollowingListLimitModel;
});

